import { Box, FormControl, LinearProgress, styled as MUIStyled, Stack } from '@mui/material'
import { Button, Image, Text, confirmDialog } from 'components/ui'
import { Field, FieldConfig, FieldProps } from 'formik'
import { sizeFormat } from 'pages/ticket/utils'
import React, { useEffect, useRef, useState } from 'react'
import { Label } from '../ui/Label'
import { isAudioUrl, isImage, isVideoUrl } from 'utils/validate'
import { MessageBox, renderDialog } from 'components/ui/UiDialog'
import { getFileUrl } from 'utils/common'
import { maxFileSize, maxFileSizeMb } from 'config'
import { isArray } from 'lodash'

const IconPdf = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.19911 0H18.8978L27.9652 9.45128V27.8341C27.9652 30.1369 26.1022 32 23.8073 32H8.19911C5.89627 32 4.0332 30.1369 4.0332 27.8341V4.1659C4.03316 1.86306 5.89622 0 8.19911 0Z"
      fill="#E5252A"
    />
    <path
      opacity="0.302"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.8887 0V9.37931H27.9641L18.8887 0Z"
      fill="white"
    />
    <path
      d="M8.66211 23.8761V18.031H11.1489C11.7646 18.031 12.2523 18.1989 12.6202 18.5428C12.988 18.8786 13.1719 19.3344 13.1719 19.9021C13.1719 20.4698 12.988 20.9256 12.6202 21.2614C12.2523 21.6052 11.7646 21.7731 11.1489 21.7731H10.1574V23.8761H8.66211ZM10.1574 20.5018H10.981C11.2048 20.5018 11.3808 20.4538 11.5007 20.3419C11.6206 20.2379 11.6846 20.094 11.6846 19.9021C11.6846 19.7102 11.6207 19.5663 11.5007 19.4623C11.3808 19.3504 11.2049 19.3024 10.981 19.3024H10.1574V20.5018ZM13.7875 23.8761V18.031H15.8585C16.2663 18.031 16.6501 18.087 17.0099 18.2069C17.3697 18.3268 17.6976 18.4948 17.9854 18.7267C18.2733 18.9505 18.5052 19.2544 18.6731 19.6382C18.833 20.022 18.921 20.4618 18.921 20.9575C18.921 21.4453 18.833 21.8851 18.6731 22.2689C18.5052 22.6527 18.2733 22.9565 17.9854 23.1804C17.6976 23.4123 17.3697 23.5802 17.0099 23.7002C16.6501 23.8201 16.2663 23.8761 15.8585 23.8761H13.7875ZM15.2508 22.6047H15.6826C15.9145 22.6047 16.1304 22.5808 16.3303 22.5248C16.5222 22.4688 16.7061 22.3808 16.882 22.2609C17.0499 22.141 17.1858 21.973 17.2818 21.7492C17.3777 21.5253 17.4257 21.2614 17.4257 20.9575C17.4257 20.6457 17.3777 20.3818 17.2818 20.158C17.1858 19.9341 17.0499 19.7662 16.882 19.6462C16.7061 19.5263 16.5222 19.4383 16.3303 19.3824C16.1304 19.3264 15.9145 19.3024 15.6826 19.3024H15.2508V22.6047ZM19.6726 23.8761V18.031H23.8305V19.3024H21.1679V20.2379H23.2948V21.5013H21.1679V23.8761H19.6726Z"
      fill="white"
    />
  </svg>
)
const IconDoc = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3293_214671)">
      <path
        d="M8.19603 0.000488281H18.903L27.9664 9.45642V27.8377C27.9664 30.1369 26.1028 32.0005 23.8035 32.0005H8.19603C5.89675 32.0005 4.0332 30.1369 4.0332 27.8377V4.16332C4.0332 1.86408 5.89675 0.000488281 8.19603 0.000488281Z"
        fill="#0263D1"
      />
      <path
        opacity="0.302"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8906 0.000488281V9.37875H27.9669L18.8906 0.000488281Z"
        fill="white"
      />
      <path
        d="M7.89844 22.8336V17.5362H9.77496C10.1503 17.5362 10.4997 17.5923 10.8232 17.6959C11.1468 17.8037 11.4401 17.959 11.7033 18.1661C11.9664 18.3731 12.1735 18.6492 12.3245 18.9943C12.4755 19.3394 12.5531 19.7363 12.5531 20.1849C12.5531 20.6336 12.4755 21.0304 12.3245 21.3755C12.1735 21.7206 11.9664 21.9967 11.7033 22.2038C11.4402 22.4108 11.1468 22.5661 10.8232 22.674C10.4997 22.7775 10.1503 22.8336 9.77496 22.8336H7.89844ZM9.22278 21.6818H9.61534C9.82672 21.6818 10.0252 21.656 10.202 21.6085C10.3832 21.5567 10.5471 21.4748 10.7024 21.3669C10.8577 21.259 10.9785 21.1038 11.0647 20.901C11.1553 20.7026 11.1984 20.461 11.1984 20.1849C11.1984 19.9089 11.1553 19.6673 11.0647 19.4645C10.9785 19.2661 10.8577 19.1108 10.7024 19.0029C10.5471 18.8908 10.3832 18.8132 10.202 18.7614C10.0252 18.7139 9.82672 18.688 9.61534 18.688H9.22278V21.6818ZM15.7669 22.894C14.9688 22.894 14.3088 22.6352 13.7869 22.1219C13.2649 21.6085 13.006 20.9614 13.006 20.185C13.006 19.4085 13.2649 18.7614 13.7869 18.2481C14.3088 17.7347 14.9688 17.4759 15.7669 17.4759C16.552 17.4759 17.2034 17.7348 17.7254 18.2481C18.243 18.7614 18.5019 19.4085 18.5019 20.185C18.5019 20.9614 18.243 21.6085 17.7254 22.1219C17.2034 22.6352 16.552 22.894 15.7669 22.894ZM14.7488 21.3022C15.0119 21.5956 15.3484 21.7422 15.7582 21.7422C16.1681 21.7422 16.5002 21.5956 16.7634 21.3022C17.0265 21.0046 17.1559 20.6336 17.1559 20.1849C17.1559 19.7363 17.0265 19.3653 16.7634 19.0676C16.5002 18.7743 16.1681 18.6276 15.7582 18.6276C15.3484 18.6276 15.0119 18.7743 14.7488 19.0676C14.4857 19.3653 14.3519 19.7363 14.3519 20.1849C14.3519 20.6336 14.4857 21.0046 14.7488 21.3022ZM21.6509 22.894C20.8788 22.894 20.236 22.6524 19.727 22.1779C19.2136 21.6991 18.9592 21.0348 18.9592 20.1849C18.9592 19.3394 19.218 18.6751 19.7356 18.1962C20.2576 17.7174 20.8918 17.4758 21.651 17.4758C22.3369 17.4758 22.8977 17.6441 23.342 17.9849C23.782 18.3213 24.0366 18.77 24.1012 19.3308L22.764 19.6025C22.7079 19.3092 22.5741 19.072 22.3671 18.8951C22.16 18.7182 21.9184 18.6276 21.6423 18.6276C21.2627 18.6276 20.9478 18.7614 20.6933 19.0331C20.4388 19.3092 20.3093 19.6888 20.3093 20.1849C20.3093 20.681 20.4388 21.0606 20.689 21.3324C20.9435 21.6085 21.2584 21.7422 21.6423 21.7422C21.9184 21.7422 22.1557 21.6646 22.3498 21.5093C22.5439 21.354 22.6647 21.1469 22.7164 20.8881L24.0839 21.1987C23.9588 21.7336 23.6827 22.1477 23.2514 22.4454C22.8243 22.7431 22.2894 22.894 21.6509 22.894Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3293_214671">
        <rect width="32" height="32" fill="white" transform="translate(0 0.000488281)" />
      </clipPath>
    </defs>
  </svg>
)
const IconXls = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3293_214631)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.19869 0.000244141H18.9014L27.9669 9.45816V27.8328C27.9669 30.133 26.0997 32.0002 23.7995 32.0002H8.19869C5.89848 32.0002 4.03125 30.133 4.03125 27.8328V4.16768C4.03125 1.86747 5.89848 0.000244141 8.19869 0.000244141Z"
        fill="#00733B"
      />
      <path
        opacity="0.302"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8867 0.000244141V9.37697H27.9658L18.8867 0.000244141Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0801 23.4759H15.3287V25.0861H11.0801V23.4759ZM16.6547 15.2493H20.9169V16.8459H16.6547V15.2493ZM11.0801 15.2493H15.3287V16.8459H11.0801V15.2493ZM16.6547 17.9554H20.9169V19.5655H16.6547V17.9554ZM11.0801 17.9554H15.3287V19.5655H11.0801V17.9554ZM16.6547 20.7698H20.9169V22.3799H16.6547V20.7698ZM11.0801 20.7698H15.3287V22.3799H11.0801V20.7698ZM16.6547 23.4759H20.9169V25.0861H16.6547V23.4759Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3293_214631">
        <rect width="32" height="32" fill="white" transform="translate(0 0.000244141)" />
      </clipPath>
    </defs>
  </svg>
)
const IconXlsx = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3293_214631)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.19869 0.000244141H18.9014L27.9669 9.45816V27.8328C27.9669 30.133 26.0997 32.0002 23.7995 32.0002H8.19869C5.89848 32.0002 4.03125 30.133 4.03125 27.8328V4.16768C4.03125 1.86747 5.89848 0.000244141 8.19869 0.000244141Z"
        fill="#00733B"
      />
      <path
        opacity="0.302"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8867 0.000244141V9.37697H27.9658L18.8867 0.000244141Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0801 23.4759H15.3287V25.0861H11.0801V23.4759ZM16.6547 15.2493H20.9169V16.8459H16.6547V15.2493ZM11.0801 15.2493H15.3287V16.8459H11.0801V15.2493ZM16.6547 17.9554H20.9169V19.5655H16.6547V17.9554ZM11.0801 17.9554H15.3287V19.5655H11.0801V17.9554ZM16.6547 20.7698H20.9169V22.3799H16.6547V20.7698ZM11.0801 20.7698H15.3287V22.3799H11.0801V20.7698ZM16.6547 23.4759H20.9169V25.0861H16.6547V23.4759Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3293_214631">
        <rect width="32" height="32" fill="white" transform="translate(0 0.000244141)" />
      </clipPath>
    </defs>
  </svg>
)
const IconZip = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3293_214719)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.19429 0.000488281H18.897L27.9668 9.45391V27.8394C27.9668 30.1314 26.0977 32.0005 23.8057 32.0005H8.19429C5.89242 32.0005 4.0332 30.1314 4.0332 27.8394V4.16158C4.0332 1.85971 5.89242 0.000488281 8.19429 0.000488281Z"
        fill="#FFB11F"
      />
      <path
        opacity="0.302"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8867 0.000488281V9.37523H27.9663L18.8867 0.000488281Z"
        fill="white"
      />
      <path
        d="M12.8467 16.6252V14.4413C12.8467 14.2052 12.6597 14.0183 12.4237 14.0183H11.2432C11.0071 14.0183 10.8202 14.2052 10.8202 14.4413V16.6252L10.1611 18.5532C9.97421 19.0943 10.0628 19.6944 10.3972 20.1567C10.7218 20.619 11.2629 20.8945 11.8334 20.8945C12.404 20.8945 12.9352 20.619 13.2697 20.1567C13.6041 19.6944 13.6926 19.0943 13.5057 18.5532L12.8467 16.6252ZM12.5712 19.655C12.2368 20.137 11.4301 20.137 11.0858 19.655C10.9186 19.4189 10.8694 19.1041 10.9678 18.8287L11.1842 18.1794H12.4729L12.6991 18.8287C12.7877 19.1041 12.7483 19.4189 12.5712 19.655ZM9.2168 2.29254V3.49268C9.2168 3.72876 9.40371 3.91568 9.6398 3.91568H11.2432V5.70604H9.6398C9.40371 5.70604 9.2168 5.89296 9.2168 6.12904V7.05372C9.2168 7.2898 9.40371 7.48654 9.6398 7.48654H11.2432V9.26704H9.6398C9.40371 9.26704 9.2168 9.45396 9.2168 9.69004V10.6245C9.2168 10.8606 9.40371 11.0475 9.6398 11.0475H11.2432V12.405C11.2432 12.6411 11.44 12.828 11.6761 12.828H14.0271C14.2534 12.828 14.4501 12.6411 14.4501 12.405V11.4705C14.4501 11.2443 14.2534 11.0475 14.0271 11.0475H12.4139V9.26704H14.0271C14.2534 9.26704 14.4501 9.08013 14.4501 8.84405V7.90954C14.4501 7.67346 14.2534 7.48654 14.0271 7.48654H12.4139V5.70604H14.0271C14.2534 5.70604 14.4501 5.5093 14.4501 5.27322V4.34854C14.4501 4.11246 14.2534 3.91572 14.0271 3.91572H12.4139V2.28271C12.4138 2.28271 9.2168 2.29254 9.2168 2.29254Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3293_214719">
        <rect width="32" height="32" fill="white" transform="translate(0 0.000488281)" />
      </clipPath>
    </defs>
  </svg>
)
const IconFile = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3293_214719)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.19429 0.000488281H18.897L27.9668 9.45391V27.8394C27.9668 30.1314 26.0977 32.0005 23.8057 32.0005H8.19429C5.89242 32.0005 4.0332 30.1314 4.0332 27.8394V4.16158C4.0332 1.85971 5.89242 0.000488281 8.19429 0.000488281Z"
        fill="#bbb"
      />
      <path
        opacity="0.302"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.8867 0.000488281V9.37523H27.9663L18.8867 0.000488281Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3293_214719">
        <rect width="32" height="32" fill="white" transform="translate(0 0.000488281)" />
      </clipPath>
    </defs>
  </svg>
)

const EXTENSION = {
  jpeg: { mime: 'image/jpeg', icon: <IconFile /> },
  gif: { mime: 'image/gif', icon: <IconFile /> },
  video: { mime: 'video', icon: <IconFile /> },
  png: { mime: 'image/png', icon: <IconFile /> },
  pdf: { mime: 'application/pdf', icon: <IconPdf /> },
  xlsx: { mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', icon: <IconXlsx /> },
  xls: { mime: 'application/vnd.ms-excel', icon: <IconXls /> },
  ppt: { mime: 'application/vnd.ms-powerpoint', icon: <IconFile /> },
  pptx: { mime: 'application/vnd.openxmlformats-officedocument.presentationml.presentation', icon: <IconFile /> },
  docx: { mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', icon: <IconFile /> },
  doc: { mime: 'application/msword', icon: <IconDoc /> },
  zip: { mime: 'application/zip', icon: <IconZip /> },
}

const EXTENSION_GROUP = {
  image: [EXTENSION.jpeg, EXTENSION.png, EXTENSION.gif, EXTENSION.video],
  office: [EXTENSION.pdf, EXTENSION.xlsx, EXTENSION.xls, EXTENSION.ppt, EXTENSION.pptx, EXTENSION.docx, EXTENSION.doc],
}

const DragUploadComponent = MUIStyled('div')({
  '.file-item .button-img-viewer': { display: 'none' },
  '.file-item.--done .button-img-viewer': { display: 'inline-flex' },
})
const DragDropComponent = MUIStyled('div')({
  backgroundColor: '#EFF6FF',
  '.drag-info': {
    opacity: 0,
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  '&.--drag-drop': {
    backgroundColor: '#BFDBFE',
    '.upload-info': { opacity: 0 },
    '.drag-info': {
      opacity: 1,
    },
  },
})

/**
 * @typedef {object} IFileAttachmentProps
 * @property {string} [label]
 * @property {boolean} [requiredLabel]
 * @property {FormControlProps} [propsContainer]
 * @property {(keyof typeof EXTENSION)[] | (keyof typeof EXTENSION)} [accept]
 * @property {(keyof typeof EXTENSION_GROUP)[] | (keyof typeof EXTENSION_GROUP)} [acceptGroup]
 * @property {boolean} [multiple]
 * @property {string} [title]
 * @property {string} [subTitle]
 * @property {number} [maxSize]
 * @property {(e: IFile) => Promise<{error?:string, url?: string, id: string}>} [onUpload]
 */
/**
 * @typedef {object} IFile
 * @property {number|string} id
 * @property {File} file
 * @property {string} title
 * @property {string} name
 * @property {string} mime
 * @property {string} ext
 * @property {boolean} isAccept
 * @property {boolean} isSizeAccept
 * @property {boolean} isImage
 * @property {React.ReactNode} preview
 * @property {'uploading' | 'error' | 'done' | 'selected'} status
 * @property {number} size
 * @property {string} [error]
 * @property {string} [url]
 */
/**
 * @param {IFileAttachmentProps & FieldProps  & React.PropsWithChildren} props
 * @returns
 */
export const FileAttachment = (props) => {
  const {
    label,
    requiredLabel,
    propsContainer,
    accept: _accept,
    acceptGroup: _acceptGroup,
    multiple = true,
    title = 'Kéo và thả hoặc chọn file để tải lên',
    subTitle = `Tải lên các định dạng .jpg, .gif, .png, .doc, .dpf, .ppt, .xlsx. Mỗi file tối đa ${maxFileSizeMb}MB.`,
    maxSize = maxFileSize,
    onUpload: _onUpload,
    form,
    field,
    editable = true,
    type = ''
  } = props

  /**@type {React.RefObject<HTMLDivElement>}*/
  const refForm = useRef()
  /**@type {React.RefObject<HTMLInputElement>}*/
  const refInput = useRef()

  /**@type {[IFile[], React.Dispatch<React.SetStateAction<IFile[]>>]}*/
  const [files, setFiles] = useState([])

  const [isUpdate, setIsUpdate] = useState(new Date().getTime())

  const accept = _accept === undefined ? undefined : Array.isArray(_accept) ? _accept : [_accept]
  const acceptGroup =
    _acceptGroup === undefined
      ? _accept === undefined
        ? ['image']
        : []
      : Array.isArray(_acceptGroup)
        ? _acceptGroup
        : [_acceptGroup]
  const mimeAccept =
    (acceptGroup !== undefined && (acceptGroup || []).length) > 0
      ? acceptGroup.map((e) => EXTENSION_GROUP[e]).flat()
      : accept.map((e) => EXTENSION[e]).filter((e) => !!e)

  useEffect(() => {
    init()
    return () => {
      refForm.current?.removeEventListener('dragover', startDragDrop)
      refForm.current?.removeEventListener('dragleave', leaveDragDrop)
      refForm.current?.removeEventListener('dragenter', startDragDrop)
      refForm.current?.removeEventListener('drop', onDrop)
    }
  }, [])

  const init = async () => {
    refForm.current?.addEventListener('dragover', startDragDrop)
    refForm.current?.addEventListener('dragleave', leaveDragDrop)
    refForm.current?.addEventListener('dragenter', startDragDrop)
    refForm.current?.addEventListener('drop', onDrop)
  }

  const startDragDrop = (e) => {
    console.log('startDragDrop')
    e.preventDefault()
    e.stopPropagation()
    refForm.current?.classList.add('--drag-drop')
  }

  const leaveDragDrop = (e) => {
    console.log('leaveDragDrop')
    e.preventDefault()
    e.stopPropagation()
    refForm.current?.classList.remove('--drag-drop')
  }

  const onDrop = (e) => {
    console.log('onDrop')
    e.preventDefault()
    e.stopPropagation()
    refForm.current?.classList.remove('--drag-drop')

    let draggedData = e.dataTransfer
    fileHandler(Array.from(draggedData.files))
  }

  const onChangeForm = (v) => {
    return form?.setFieldValue(field.name, type === 'post' ? [...v] : [...(field.value || []), ...v])
  }

  const handlePreviewImgFile = (e, data) => {
    renderDialog(
      <MessageBox open={true}>
        <Image
          src={data}
          alt=""
          style={{
            width: '100%',
            height: '100%',
            aspectRatio: 1.5,
            objectFit: 'contain',
          }}
        />
      </MessageBox>
    )
    e.preventDefault()
  }

  /** @param {File[]} files */
  const fileHandler = async (files) => {
    const time = new Date().getTime()
    const f = await Promise.all(
      files.map(async (file, index) => {
        const { name: title, type: _mime } = file
        const isImage = EXTENSION_GROUP.image.map((e) => e.mime).includes(_mime)
        const accept = mimeAccept.find((e) => {
          return e.mime === _mime || _mime.slice(0, 5) === "video"
        })
        const isAccept = accept !== undefined
        const isSizeAccept = file.size <= maxSize
        const mime = Object.entries(EXTENSION).find(([k, e]) => e.mime === _mime)?.[1]
        const ext = /\.(\w+)$/.test(title) ? RegExp.$1 : ''
        const name = /(.*)(?:\.\w+){0,}$/gm.test(title) ? RegExp.$1 : title
        let error = !isAccept
          ? 'File không được hỗ trợ để tải lên.'
          : !isSizeAccept
            ? 'Vượt quá dung lượng cho phép.'
            : undefined

        console.log('file', file)

        const imgSource = isImage
          ? await new Promise((resolve, reject) => {
            let reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onloadend = () => {
              resolve(reader.result)
            }

            reader.onerror = (e) => reject(e.message)
          }).catch((e) => {
            error = e
            return undefined
          })
          : undefined

        /**@type {IFile} */
        const data = {
          id: time + index,
          file,
          status: error ? 'error' : _onUpload !== undefined ? 'uploading' : 'selected',
          size: file.size,
          title,
          name: name,
          mime: _mime,
          ext,
          isAccept: isAccept,
          isSizeAccept: isSizeAccept,
          isImage,
          error,
          preview: isImage ? (
            <Box position={'relative'}>
              <Image
                src={imgSource}
                width={40}
                height={40}
                style={{ background: 'black', objectFit: 'contain', borderRadius: 6 }}
              />
              <Button
                className="button-img-viewer"
                typeButton="icon"
                style={{ position: 'absolute', right: 2, top: 2, background: 'rgba(0,0,0,.3)', borderWidth: 0 }}
                onClick={(e) => handlePreviewImgFile(e, URL.createObjectURL(file))}
              >
                <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.251 13.906h3.5c3.168 0 4.521-1.353 4.521-4.52V8.217a.44.44 0 0 0-.437-.437.44.44 0 0 0-.438.437v1.167c0 2.69-.957 3.646-3.646 3.646h-3.5c-2.689 0-3.646-.957-3.646-3.646v-3.5c0-2.689.957-3.646 3.646-3.646h1.167a.44.44 0 0 0 .437-.437.44.44 0 0 0-.437-.438H5.251c-3.167 0-4.52 1.354-4.52 4.521v3.5c0 3.168 1.353 4.521 4.52 4.521Zm7.584-8.867a.44.44 0 0 1-.438-.437V2.858L7.894 7.36a.433.433 0 0 1-.31.128.433.433 0 0 1-.309-.128.44.44 0 0 1 0-.618l4.504-4.504h-1.744a.44.44 0 0 1-.438-.437.44.44 0 0 1 .438-.438h2.8a.44.44 0 0 1 .437.438v2.8a.44.44 0 0 1-.437.437Z"
                    fill="#fff"
                  />
                </svg>
              </Button>
            </Box>
          ) : (
            mime?.icon || <IconFile />
          ),
        }

        !!!error && onUpload(data)
        return data
      })
    )
    setFiles((s) => {
      s = [...s, ...f]
      onChangeForm(s)
      return s
    })
  }

  /** @param {IFile} e */
  const onUpload = async (e) => {
    const resp = await _onUpload?.(e)
    const { error, url, id } = resp
    setFiles((s) => {
      const index = s.findIndex((e1) => e1.id === e.id)
      if (index >= 0)
        s[index] = {
          ...s[index],
          url,
          ...(!!error && { error: error, status: 'error' }),
          ...(!!url && { error: undefined, status: 'done' }),
          ...(!!id && { id }),
        }

      onChangeForm(s)
      return s
    })
    setIsUpdate(new Date().getTime())
  }

  /** @param {IFile} e */
  const onReUpload = (e) => {
    const index = files.findIndex((e1) => e1.id === e.id)
    files[index] = {
      ...files[index],
      status: 'uploading',
      error: undefined,
      url: undefined,
    }

    setFiles(files)
    setIsUpdate(new Date().getTime())
    onUpload(e)
  }

  const onChangeInput = (e) => {
    fileHandler(Array.from(e.target.files))
    e.target.value = ''
  }

  // console.log('field', field)

  const touched = form?.touched[field.name]
  const error = form?.errors[field.name]
  const isError = touched === true && !!error

  const fileAccept = files.filter((e) => e.isAccept && e.isSizeAccept)
  return (
    <FormControl fullWidth {...propsContainer} error={isError}>
      {label && <Label required={requiredLabel}>{label}</Label>}
      <DragUploadComponent>
        <DragDropComponent
          ref={refForm}
          className="upload-drag-drop"
          style={{
            borderStyle: 'dashed',
            borderColor: '#60A5FA',
            borderWidth: 1,
            borderRadius: 6,
            padding: 16,
            alignItems: 'center',
            position: 'relative',
            zIndex: 2,
          }}
        >
          <Stack
            zIndex={-1}
            className="drag-info"
            alignItems={'center'}
            style={{ width: '100%' }}
            justifyContent={'center'}
          >
            <Text color="#525252">{'+ Kéo thả file vào đây'}</Text>
          </Stack>
          <Stack
            direction="row"
            spacing="12px"
            zIndex={1}
            className="upload-info"
            alignItems={'center'}
            style={{ width: '100%' }}
          >
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M25.8203 5.7429C21.5206 5.65691 17.0857 8.11916 15.8691 13.675C10.9178 11.985 6.44723 15.3182 6.91162 20.6403C4.321 21.6875 2.5 24.2184 2.5 27.1931C2.5 31.11 5.65334 34.2634 9.57031 34.2634H18.1592C18.1568 31.8829 18.1518 27.1066 18.1518 26.2018L16.1377 26.9318C14.6765 27.5615 13.5972 25.7215 14.8486 24.5758L18.6596 20.8722C19.5301 20.0017 20.5697 20.1016 21.3403 20.8722L25.1514 24.5758C26.4027 25.7215 25.3235 27.5615 23.8623 26.9318L21.8481 26.2018V34.2634H30.4297C34.3467 34.2634 37.5 31.11 37.5 27.1931C37.5 24.3101 35.7888 21.8457 33.3252 20.7428C38.0988 11.4366 32.1045 5.86838 25.8203 5.7429Z"
                fill="#75B5FF"
              />
              <path
                d="M25.8194 5.7416C25.5799 5.73688 25.317 5.7451 25.0772 5.75573C19.5855 14.4106 28.0727 20.7411 33.3243 20.7411C38.0979 11.4348 32.1036 5.86708 25.8194 5.7416Z"
                fill="#488BFF"
              />
            </svg>
            <div style={{ flexGrow: 1 }}>
              {title && <Text textAlign={'left'}>{title}</Text>}
              {subTitle && (
                <Text color={'#737373'} fontSize={12} textAlign={'left'}>
                  {subTitle}
                </Text>
              )}
            </div>
            <Button sx={{ px: 2, mt: 1, py: 1 / 2 }} onClick={() => refInput.current?.click()}>
              {'Chọn file'}
            </Button>
          </Stack>
          <input
            ref={refInput}
            type="file"
            {...(multiple && { multiple: true })}
            accept={mimeAccept.map((e) => e.mime).join(',')}
            style={{ display: 'none' }}
            onChange={onChangeInput}
          />
        </DragDropComponent>
        {fileAccept?.length > 0 && (
          <Text pt={2}>{`Đã tải lên: ${fileAccept.filter((e) => e.status === 'done')?.length}/${fileAccept?.length
            }`}</Text>
        )}
        {files.length > 0 && (
          <Stack pt={2} direction={'row'} sx={{ gap: '12px' }} flexWrap={'wrap'} useFlexGap>
            {files.map((e, index) => (
              <Box
                key={index}
                sx={{ width: { xs: '100%', sm: '48%', lineHeight: 0 } }}
                className={`file-item ${e.status === 'done' && '--done'}`}
              >
                <Stack
                  border={'1px solid'}
                  borderRadius={'6px'}
                  borderColor="#E5E5E5"
                  sx={{ px: 1, py: 1 }}
                  {...(e.error && { borderColor: '#FCA5A5', backgroundColor: '#FFF1F2' })}
                  spacing={1}
                >
                  <Stack display={'flex'} direction={'row'} alignItems={'center'}>
                    {e.preview}
                    <Box flex={1} px={2 * 0.75}>
                      <Text
                        color={'#333333'}
                        sx={{ maxWidth: { xs: 60, sm: 120, md: 220, lg: 250 } }}
                        style={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {e.title}
                      </Text>
                      {e.error ? (
                        <Text color={'#FF3141'} fontSize={12}>
                          {e.error}
                        </Text>
                      ) : (
                        <Text color={'#A3A3A3'} fontSize={12}>
                          {sizeFormat(e.size)}
                        </Text>
                      )}
                    </Box>
                    <Stack direction={'row'} spacing={1}>
                      {e.error
                        ? e.isAccept &&
                        e.isSizeAccept && (
                          <Button
                            typeButton="icon"
                            style={{ ...(e.error && { background: 'white' }) }}
                            onClick={() => onReUpload(e)}
                          >
                            <svg
                              width="16"
                              height="18"
                              viewBox="0 0 16 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M4.221 3.96a.603.603 0 0 1-.1-.079.613.613 0 0 1-.17-.303.618.618 0 0 1 .164-.586L6.494.26A.622.622 0 0 1 7.377.2a.63.63 0 0 1 .059.884L6.278 2.41a8.924 8.924 0 0 1 1.724-.168c4.334 0 7.85 3.525 7.85 7.85 0 4.325-3.516 7.866-7.85 7.866-4.333 0-7.85-3.525-7.85-7.85 0-1.558.459-3.066 1.325-4.366a.63.63 0 0 1 .867-.175.63.63 0 0 1 .175.866A6.604 6.604 0 0 0 8.011 16.7c3.641 0 6.6-2.958 6.6-6.6 0-3.642-2.967-6.6-6.609-6.6-.668 0-1.323.082-1.95.247l1.684 1.228c.275.2.341.592.133.875a.591.591 0 0 1-.5.259.66.66 0 0 1-.367-.117L4.221 3.961Z"
                                fill="#737373"
                              />
                            </svg>
                          </Button>
                        )
                        : e.status === 'done' &&
                        e.url && (
                          <Button
                            typeButton="icon"
                            style={{ ...(e.error && { background: 'white' }) }}
                            href={e.url}
                            target="_blank"
                          >
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 18 18"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M8.377 10.826 6.652 9.1a.629.629 0 0 0-.884 0 .629.629 0 0 0 0 .883l2.792 2.792a.618.618 0 0 0 .442.183.618.618 0 0 0 .441-.183l2.792-2.792a.629.629 0 0 0 0-.883.629.629 0 0 0-.883 0l-1.725 1.725V.668a.63.63 0 0 0-.625-.625.63.63 0 0 0-.625.625v10.158Zm3.341 6.717H6.285c-4.092 0-5.842-1.75-5.842-5.842v-.108c0-3.7 1.459-5.483 4.725-5.792a.643.643 0 0 1 .684.567.626.626 0 0 1-.567.683c-2.617.242-3.592 1.475-3.592 4.55v.109c0 3.391 1.2 4.591 4.592 4.591h5.433c3.392 0 4.592-1.2 4.592-4.591v-.11c0-3.091-.992-4.325-3.658-4.55a.624.624 0 0 1 .108-1.241c3.317.283 4.8 2.075 4.8 5.8v.108c0 4.075-1.75 5.825-5.842 5.825Z"
                                fill="#737373"
                              />
                            </svg>
                          </Button>
                        )}
                      <Button
                        typeButton="icon"
                        style={{ ...(e.error && { background: 'white' }) }}
                        onClick={() =>
                          confirmDialog({
                            ok: () => {
                              const v = files.filter((e1) => e1.id !== e.id)
                              setFiles(v)
                              onChangeForm(v)
                            },
                          })
                        }
                      >
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M5.73 4.845a.63.63 0 0 0-.885 0 .63.63 0 0 0 0 .884l4.272 4.272-4.272 4.272a.63.63 0 0 0 0 .884.63.63 0 0 0 .884 0l4.272-4.272 4.272 4.272a.63.63 0 0 0 .884 0 .63.63 0 0 0 0-.884l-4.272-4.272 4.272-4.272a.63.63 0 0 0 0-.884.63.63 0 0 0-.884 0l-4.272 4.272L5.73 4.845Z"
                            fill="#737373"
                          />
                        </svg>
                      </Button>
                    </Stack>
                  </Stack>
                  {e.status === 'uploading' && (
                    <LinearProgress style={{ background: '#00B578', paddingTop: 5, borderRadius: 4 }} />
                  )}
                </Stack>
              </Box>
            ))}
          </Stack>
        )}
      </DragUploadComponent>
    </FormControl>
  )
}

/**
 * @param {IFileAttachmentProps & FieldConfig} props
 * @returns
 */
export const FieldFileAttachment = (props) => <Field {...props} component={FileAttachment} />
